export default "__VITE_ASSET__BZVdhfFL__"